import { ArticlePageResolver } from "./ArticlePageResolver";
import { PageProviders } from "./PageProviders";

export const ArticlePageProviders = () => (
  <PageProviders>
    <ArticlePageResolver />
  </PageProviders>
);
